module.exports = __webpack_public_path__ + "img/brand.d8cff71e.svg";